export const PrivacySection4 = () => {
  return (
    <>
      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          9. Cookies and Tracking Technologies
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            We use cookies and similar tracking technologies to track activity on our Service and
            store certain information. These technologies help us improve your experience and
            analyze how you use our platform.
          </p>
          <p>
            For detailed information about the cookies we use and how to manage them, please see our{' '}
            <a href="/cookies" className="text-blue-600 underline hover:text-blue-800">
              Cookies Policy
            </a>
            .
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          10. International Data Transfers
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            Your information may be transferred to and maintained on computers located outside of
            your state, province, country, or other governmental jurisdiction where data protection
            laws may differ.
          </p>
          <p>
            If you are located outside the United States and choose to provide information to us,
            please note that we transfer the data, including personal information, to the United
            States and process it there.
          </p>
          <p>
            We will take all steps reasonably necessary to ensure that your data is treated securely
            and in accordance with this Privacy Policy.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Children's Privacy</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            Our Service is not directed to individuals under the age of 18. We do not knowingly
            collect personal information from children under 18.
          </p>
          <p>
            If you are a parent or guardian and you are aware that your child has provided us with
            personal information, please contact us. If we become aware that we have collected
            personal information from children without verification of parental consent, we will
            take steps to remove that information from our servers.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          12. Changes to This Privacy Policy
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes
            by:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Posting the new Privacy Policy on this page</li>
            <li>Updating the "Last updated" date at the top of this policy</li>
            <li>
              Sending you an email notification (for material changes that affect your rights)
            </li>
          </ul>
          <p>
            You are advised to review this Privacy Policy periodically for any changes. Changes to
            this Privacy Policy are effective when they are posted on this page.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Contact Us</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our
            data practices, please contact us:
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-2">WinGrow</p>
            <p>
              Email:{' '}
              <a
                href="mailto:viprielt24@gmail.com"
                className="text-blue-600 underline hover:text-blue-800"
              >
                viprielt24@gmail.com
              </a>
            </p>
            <p>Website: wingrow.io</p>
          </div>
          <p>
            We will respond to your inquiry within a reasonable timeframe, typically within 2
            business days.
          </p>
        </div>
      </section>
    </>
  );
};
